export default {"src":"/_next/static/media/desmos-scientific.c940b597.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};